import { render, staticRenderFns } from "./Ftb.vue?vue&type=template&id=3a989c64&scoped=true&"
import script from "./Ftb.vue?vue&type=script&lang=js&"
export * from "./Ftb.vue?vue&type=script&lang=js&"
import style0 from "./Ftb.vue?vue&type=style&index=0&id=3a989c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a989c64",
  null
  
)

component.options.__file = "Ftb.vue"
export default component.exports